<template>
    <div id="app">
        <transition name="fade">
            <router-view></router-view>
        </transition>
        <div class="beian" v-if="showbeian"
            style="position: absolute;bottom: 0px;height: 40px;line-height: 40px;width: 200px;text-align: center;font-size: 14px;left: 50%;transform: translate(-50%, 0px);">
            <a href="https://beian.miit.gov.cn/">
                粤ICP备2025383253号-1
            </a>
        </div>
    </div>
</template>

<script>
import BrowserStorage from './utils/utils-browser-storage';

export default {
    data() {
        return {
            showbeian: true,
        }
    },
    created() {
        this.$store.commit("loginin", BrowserStorage.getItem("token"));
        setInterval(() => {
            if (window.location.href.indexOf('sign-up-form-print') > -1 || window.location.href.indexOf('referee/inputrecord') > -1) this.showbeian = false;
            else this.showbeian = true;
        }, 1500);
    }
};
</script>

<style lang="scss">
.fade-enter-active,
.fade-leave-active {
    transition: opacity 0.5s;
}

.fade-enter,
.fade-leave-to {
    opacity: 0;
}

/**  add at 2019-08-02  */
html,
body,
#app {
    width: 100%;
    height: 100%;
}

@font-face {
    font-family: 'PangMenChenDao';
    src: url('fonts/pangmenzhengdao.ttf') format('truetype');
}

@font-face {
    font-family: 'OPPOSans B';
    src: url('fonts/OPPOSans B.ttf') format('truetype');
}

@font-face {
    font-family: 'OPPOSans M';
    src: url('fonts/OPPOSans M.ttf') format('truetype');
}
</style>
